import React from 'react';
import ChallengeCard from '../ChallengeCard';
import styles from './index.module.scss';

const ACCENT_COLORS = ['yellow', 'cyan', 'green-yellow', 'blue-violet'];

const CarouselItem = ({
  item,
  index = 0,
  colorOffset = 0,
  packageType = 'challenge',
  isWeb = false,
  isStandaloneCard = false,
  onWebNavigate,
  currentZoneName,
  zoneOrder,
  packageId,
  packageIndex,
  sharedTrackingInfo: sharedTrackingInfoProp,
}) => {
  // colorOffset ensures colors continue cycling when carousel loops,
  // even when item count and color count don't match (e.g., 6 items, 4 colors)
  const accentColor =
    ACCENT_COLORS[(index + colorOffset) % ACCENT_COLORS.length];

  // Use parent-provided tracking info if available, otherwise build from carousel context
  let sharedTrackingInfo;
  if (sharedTrackingInfoProp) {
    sharedTrackingInfo = sharedTrackingInfoProp;
  } else {
    sharedTrackingInfo = {
      unit_type: 'feed',
      unit_name: `${currentZoneName}|${zoneOrder}`,
      subunit_type: 'component',
      subunit_name: `package|${packageId}`,
      position_in_unit: packageIndex,
      position_in_subunit: index,
    };

    // Web-specific override for carousel context.
    if (isWeb) {
      sharedTrackingInfo.unit_name = 'all|0';
    }
  }

  return (
    <div className={styles.carouselItemWrapper}>
      <ChallengeCard
        item={item}
        accentColor={accentColor}
        packageType={packageType}
        isWeb={isWeb}
        isStandaloneCard={isStandaloneCard}
        navigationSource="gallery"
        onWebNavigate={onWebNavigate}
        sharedTrackingInfo={sharedTrackingInfo}
      />
    </div>
  );
};

export default CarouselItem;
